(function (window, angular, undefined) {
    angular.module('formApp')
        .directive('anzAccountNumber', [function () {

            function pad(num, size) {
                var s = num+"";
                while (s.length < size) {
                    s = "0" + s;
                }
                return s;
            }

            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attr, ngModel) {
                    ngModel.$parsers.push(function (value) {
                        if (ngModel.$viewValue.length === 8) {
                            return pad(value, 8);
                        } else {
                            return value;
                        }
                    });
                }
            };
        }]);
})(window, window.angular);